import { render, staticRenderFns } from "./SubOshaYearModal.vue?vue&type=template&id=11665d60"
import script from "./SubOshaYearModal.vue?vue&type=script&lang=js"
export * from "./SubOshaYearModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports